export const SAVE_TABLE_DATA = "boilerplate/ImsReco/Save/SAVE_TABLE_DATA";
export const PREVIEW_TABLE_DATA = "boilerplate/ImsReco/Save/PREVIEW_TABLE_DATA";
export const COMPARATIVE_TABLE_DATA = "boilerplate/ImsReco/Save/COMPARATIVE_TABLE_DATA";
export const SELECTED_SAVE = "boilerplate/ImsReco/Save/SELECTED_SAVE";
export const SELECTED_COMPARATIVE = "boilerplate/ImsReco/Save/SELECTED_COMPARATIVE";

export const LOADER_STATUS = "boilerplate/ImsReco/Save/LOADER_STATUS";
export const headerColumns = [
  {
    value: "Preview",
    id: "1",
  },
  {
    value: "Save",
    id: "2",
  },
  {
    value: "Comparative View",
    id: "3",
  },
];
